import {
  useV2CreateWebhookSubscriptionMutation,
  useV2UpdateWebhookSubscriptionMutation,
  useV2DeleteWebhookSubscriptionMutation,
} from "@generated";
import type { V2WebhookSubscriptionResource } from "@generated";
import { WEBHOOK_SUBSCRIPTION_TYPE } from "../types";
import type { WebhookSubscriptionFormValues } from "../types";

export const buildWebhookSubscriptionData = (
  values: WebhookSubscriptionFormValues,
  id?: string
): V2WebhookSubscriptionResource =>
  ({
    type: WEBHOOK_SUBSCRIPTION_TYPE,
    ...(id ? { id: Number(id) } : {}),
    attributes: {
      "webhook-url": values.webhookUrl,
      "event-type": values.eventType,
    },
  } as unknown as V2WebhookSubscriptionResource);

export const useWebhookSubscriptionMutations = () => {
  const [create] = useV2CreateWebhookSubscriptionMutation();
  const [update] = useV2UpdateWebhookSubscriptionMutation();
  const [destroy] = useV2DeleteWebhookSubscriptionMutation();

  return {
    create: (values: WebhookSubscriptionFormValues) =>
      create({ body: { data: buildWebhookSubscriptionData(values) } }).unwrap(),
    update: (id: string, values: WebhookSubscriptionFormValues) =>
      update({
        id: Number(id),
        body: { data: buildWebhookSubscriptionData(values, id) },
      }).unwrap(),
    destroy: (id: string) => destroy({ id: Number(id) }).unwrap(),
  };
};
